import { Grid, Typography } from "@mui/material";
import { styled as styling } from "@mui/material/styles";

export const GridContainerStyled = styling(Grid)((props) => ({
  display: "flex",
  padding: "80px 120px",
  flexDirection: "column",
  alignItems: "center",
  gap: "40px",
  background: "#FFF",
  // background:
  //   "linear-gradient(91deg, rgba(255, 255, 255, 0.20) -4.38%, rgba(81, 42, 204, 0.20) 53.58%, rgba(255, 255, 255, 0.20) 113.82%)",

  [props.theme.breakpoints.down("lg")]: {
    padding: "40px 24px",
    gap: "48px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "40px 16px",
    gap: "24px",
    alignItems: "flex-start",
  },
}));

export const CardListContainer = styling(Grid)((props) => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "24px",
  width: "100%",
  height: "100%",
  padding: "30px",
  textAlign: "center",
  overflow: "hidden",
  justifyContent: "center",

  // ::before overlay only for odd cards
  ...(props.cardNumber % 2 === 0
    ? {}
    : {
        "&::before": {
          content: '""',
          position: "absolute",
          inset: 0,
          backgroundImage: `url(${props.backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.1,
          zIndex: 0,
        },
        "& > *": {
          position: "relative",
          zIndex: 1,
        },
      }),

  [props.theme.breakpoints.down("lg")]: {
    width: "100%",
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
    gap: "16px",
    maxWidth: "unset",
  },
}));

export const TaglineTitle = styling(Typography)((props) => ({
  color: "#261754",
  fontSize: "40px",
  fontWeight: "400",
  fontStyle: "normal",
  lineHeight: "48px",
  fontFamily: "Georgia",
  letterSpacing: "0.06px",
  width: "100%",
  maxWidth: "1200px",

  i: {
    fontStyle: "italic",
  },

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "24px",
    lineHeight: "28.8px",
    letterSpacing: "0.036px",
  },
}));

export const CardContainer = styling(Grid)((props) => ({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  maxWidth: "1200px",
  alignItems: "center",
  // gap: "56px 40px",
  justifyContent: "center",
  background: "rgb(240, 241, 254)",

  [props.theme.breakpoints.down("lg")]: {
    // gap: "40px 24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    gridTemplateColumns: "repeat(1, 1fr)",
    // gap: "40px",
  },
}));

export const CardImage = styling("img")((props) => ({
  height: "100%",
  width: "100%",
  flexShrink: "0",
  borderRadius: "50%",
  maxHeight: "64px",
  maxWidth: "64px",
  objectFit: "cover",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    maxHeight: "40px",
    maxWidth: "40px",
  },
}));

export const CardTextContainer = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  gap: "16px",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    gap: "8px",
    maxWidth: "unset",
  },
}));

export const CardText = styling(Typography)((props) => ({
  color: "#261754",
  fontFamily: props.type == "desc" ? "Inter" : "Inter",
  fontSize: props.type == "desc" ? "16px" : "12px",
  fontStyle: "normal",
  fontWeight: props.type == "desc" ? 400 : 400,
  lineHeight: props.type == "desc" ? "24px" : "20px",
  alignSelf: "stretch",
  letterSpacing: props.type == "desc" ? "0.15px" : "0.15px",
  fontStyle: props.type == "desc" ? "italic" : "none",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: props.type == "desc" ? "14px" : "12px",
    lineHeight: props.type == "desc" ? "21px" : "18px",
    letterSpacing: props.type == "desc" ? "unset" : "unset",
  },
}));
